import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosClient from '../../common/axiosInstance';
import { useNavigate } from 'react-router-dom';
import { useThemeContext } from 'contexts/ThemeContext';

const MotoContext = createContext();

export const useMotoContext = () => useContext(MotoContext);
export const DOCTYPE_STATUS = {
  IDLE: null,
  SUCCESS: '1',
  WARNING: 'warning',
  ERROR: '2',
  LOADING: 'loading',
  HANDLING: '3',
  CHECKING: '4', // đang kiểm tra
};

export default ({ children }) => {
  const navigate = useNavigate();
  const { changeMainColor } = useThemeContext();

  const [isLoading, setLoading] = useState(0);
  const handleLoading = (loading = true) => {
    if (loading) {
      setLoading((prev) => prev + 1);
      return;
    }
    setLoading((prev) => prev - 1);
  };

  const [information, setInformation] = useState([]);
  const [informationParams, setInformationParams] = useState(null);
  const [codeSnippet, setCodeSnippet] = useState(null);
  const [photoItems, setPhotoItems] = useState([]);
  const [messages, setMessages] = useState([]);
  const [typeMsg, setTypeMsg] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [isFetchDataDone, setFetchDataDone] = useState(false);
  const [ppiStatus, setPpiStatus] = useState(null);
  const [infoCar, setInfoCar] = useState({});
  const [isConfirmCheckout, setConfirmCheckout] = useState(false);
  const [isReExpertise, setReExpertise] = useState(false);
  const [isLoadingConfig, setLoadingConfig] = useState(false);

  // --- STATE MỚI CHO POPUP ---
  const [actionPopupData, setActionPopupData] = useState(null);
  const [selectedAction, setSelectedAction] = useState(null);
  useEffect(() => {
    if (!codeSnippet) return;
    getInfoCar(); // Lần đầu gọi không có body
    changeMainColor('#C0167C', '#fff');
  }, [codeSnippet]);

  // Sửa GET thành POST và thêm tham số extraBody
  const getInfoCar = (extraBody = {}) => {
    setLoadingConfig(true);
    return axiosClient
      .post('/momo-policy/get-info-car-autocare', { ...extraBody, encrypt: codeSnippet })
      .then((res) => {
        // LUỒNG POPUP TỪ BE
        if (res.data.action === 'SHOW_POPUP') {
          setActionPopupData(res.data.options);
          return; // Dừng lại ở đây, chờ user tương tác
        }

        // LUỒNG BÌNH THƯỜNG
        setActionPopupData(null); // Tắt popup nếu đang mở
        const {
          OwnerName,
          engineNumber,
          LicenseNumber,
          Make,
          Model,
          RequestId,
          InsurerBranchId,
          btn_bg_color,
          btn_text_color,
          chassisNumber,
          ChassisEngineNumber,
          ppi_status,
        } = res.data;
        setInfoCar(res.data);
        setPpiStatus(ppi_status);
        changeMainColor(btn_bg_color, btn_text_color);
        setRequestId(RequestId);
        setConfirmCheckout(res.data.ppi_confirm === 'Y');
        setInformationParams({
          licenseNumber: LicenseNumber,
          make: Make,
          model: Model,
          engineNumber: engineNumber,
          insurerBranchId: InsurerBranchId,
          chassisNumber: chassisNumber,
        });
        setInformation([
          { text: 'Tên chủ xe', value: OwnerName },
          { text: 'Biển số xe', value: LicenseNumber },
          { text: 'Số khung/ số máy', value: ChassisEngineNumber },
          { text: 'Nhãn hiệu', value: Make },
          { text: 'Kiểu xe', value: Model },
        ]);
        getDoctype(RequestId);
      })
      .catch((err) => {
        if (err.errors) {
          const message = err?.message?.length ? err?.message : `Lỗi network ${err.status}`;
          setMessages([{ message }]);
          setTypeMsg('error');
          navigate('/result-car/' + codeSnippet);
          return;
        }
      })
      .finally(() => {
        setLoadingConfig(false);
      });
  };

  const getDoctype = (RequestId) => {
    return axiosClient
      .get('/authentication-policy/get-doctype-autocare/' + RequestId)
      .then((res) => {
        const doctype = res.data;
        const newValue = doctype.map((x, index) => {
          return {
            name: x.name,
            image: null,
            imageSample: x.image,
            status: DOCTYPE_STATUS.IDLE,
            statusText: '',
            doctype: x.doctype,
            pvbt_doctype: x.pvbt_doctype,
            frame: x.frame,
            index: index + 1,
            uploadPercentage: 0,
            cancel: null,
            position: x.position,
          };
        });
        setPhotoItems(newValue);
      })
      .catch((err) => {
        if (err.errors) {
          const message = err?.message?.length ? err?.message : `Lỗi network ${err.status}`;
          setMessages([{ message }]);
          setTypeMsg('error');
          navigate('/result-car/' + codeSnippet);
          return;
        }
      })
      .finally(() => {
        setFetchDataDone(true);
      });
  };

  // --- HÀM XỬ LÝ KHI USER CLICK NÚT TRONG POPUP ---
  const handleSelectAction = (actionKey) => {
    setSelectedAction(actionKey);
    getInfoCar({ open_pi_action: actionKey });
  };

  return (
    <MotoContext.Provider
      value={{
        setCodeSnippet,
        loading: isLoading > 0,
        handleLoading,
        information,
        photoItems,
        setPhotoItems,
        messages,
        typeMsg,
        requestId,
        setMessages,
        setTypeMsg,
        isFetchDataDone,
        informationParams,
        isConfirmCheckout,
        isReExpertise,
        ppiStatus,
        infoCar,
        setReExpertise,
        loadingConfig: isLoadingConfig,
        // Xuất data và action cho Expertise.js
        actionPopupData,
        handleSelectAction,
        selectedAction,
      }}
    >
      {children}
    </MotoContext.Provider>
  );
};
